import * as React from "react";
import { IApplicantReport } from "../../../model/report/ApplicantReport";
import { Table, Typography } from "antd";

const ReportPreview = ({
  translate,
  data,
  title,
  subtitle
}: {
  translate?: any;
  data: IApplicantReport[];
  title?: string;
  subtitle?: string;
}) => {
  const columns = [
    {
      title: translate("document_template.applicant_id"),
      dataIndex: "applicantId",
      key: "applicantId"
    },
    {
      title: translate("document_template.party_id"),
      dataIndex: "partyId",
      key: "partyId"
    },
    {
      title: translate("document_template.first_name"),
      dataIndex: "firstName",
      key: "firstName"
    },
    {
      title: translate("document_template.father_name"),
      dataIndex: "fatherName",
      key: "fatherName"
    },
    {
      title: translate("document_template.last_name"),
      dataIndex: "lastName",
      key: "lastName"
    },
    {
      title: translate("document_template.mother_surname"),
      dataIndex: "motherSurname",
      key: "motherSurname"
    }
  ];
  return (
    <div>
      {title && (
        <Typography.Title style={{ fontSize: 14 }}>
          {`${translate("reports.params.reporting_period")}: ${title}`}
        </Typography.Title>
      )}
      <Typography.Title style={{ fontSize: 12, marginBottom: 20 }}>
        {`${translate("reports.report")}: ${subtitle}`}
      </Typography.Title>
      <Table
        bordered
        dataSource={data}
        columns={columns}
        pagination={false}
        size={"small"}
        locale={{ emptyText: translate("reports.table.no_data") }}
      />
    </div>
  );
};

export default ReportPreview;
